export default __webpack_public_path__ + "static/media/lety-logo.81d1d760.svg";